interface ProgressBarProps {
  step: number;
  total: number;
}

export function ProgressBar({ step, total }: ProgressBarProps) {
  const bounded = Math.min(Math.max(step, 1), total);
  const progress = Math.min(Math.max((bounded / total) * 100, 2), 100);

  return (
    <div
      data-testid="progress-bar"
      className="h-3 overflow-hidden rounded-full border-2 border-black bg-gray-200"
    >
      <div
        className="h-full rounded-full bg-[#FFD700]"
        style={{
          width: `${progress}%`,
          transition: "width 0.5s ease-out",
        }}
      />
    </div>
  );
}
